export const RESULT_PAGE_TRANSLATIONS = {
  answererLabel: {
    fi: "Vastaajan nimi"
  },
  companyNameLabel: {
    fi: "Yrityksen nimi"
  },
  dateLabel: {
    fi: "Päivämäärä"
  },
  horizontalBarLabel: {
    fi: "Digicap - digitasoitus (54=matalin, 0=korkein)"
  },
  radarLabel: {
    fi: "Digicap - digitaalisuuden taso (1=matala, 5=korkea)"
  },
  handicapsHeader: {
    fi: "Jos Digicap-tuloksesi on ..."
  },
  handicapResultHeader: {
    fi: "Digicap-tuloksesi on:"
  }
};
